import { render, staticRenderFns } from "./eduStats.vue?vue&type=template&id=f2363434"
import script from "./eduStats.vue?vue&type=script&lang=js"
export * from "./eduStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports